import { Checkbox, message } from 'antd';
import css from './index.module.scss';
import ApplianceModal from './Modal';
import { SolarCalcPage, getSceneAppliances, calculateTotalPower, custome } from '@/constants/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';

export default function Step3({ calObj, callBack }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('calculatorssolarpanels');
    const Appliances: any = getSceneAppliances(calObj?.check1, calObj?.check1 === 'outdoor' ? ([0, 1, 2]?.includes(calObj?.check2) ? 'type1' : 'type2') : '');
    const customeAppliance = calObj?.allAppliances && calObj?.allAppliances?.find((app: any) => app.key === 'custome');
    const [allAppliances, setAllApplicances] = useState(
        customeAppliance ? calObj?.allAppliances : calObj?.allAppliances?.length ? calObj?.allAppliances : Appliances,
    );
    const [selected, setSelected] = useState(calObj?.appliances || ([] as any));
    const [editItem, setEditItem] = useState({ item: null, visible: false, type: 'edit' });
    const [customeFlag, setCustomeFlag] = useState(!customeAppliance);
    const [checkedFlag, setCheckedFlag] = useState(Boolean(selected?.length));
    const [totalPower, setTotalPower] = useState(calObj?.totalPower ?? calculateTotalPower(allAppliances, selected));

    const handleChangeCheck = (app: any, e: any) => {
        if (e.target.checked) {
            const checkedAppliances = [...selected, app];
            !checkedFlag && setCheckedFlag(true);
            setSelected(checkedAppliances);
            const newTotalPower = calculateTotalPower(allAppliances, checkedAppliances);
            setTotalPower(newTotalPower);
            callBack({ ...calObj, allAppliances: Appliances, appliances: checkedAppliances, totalPower: newTotalPower, currentStep: 3 });
        } else {
            const checkedAppliances = selected.filter((item: any) => item.key !== app.key);
            setSelected(checkedAppliances);
            const newTotalPower = calculateTotalPower(allAppliances, checkedAppliances);
            setTotalPower(newTotalPower);
            callBack({
                ...calObj,
                allAppliances: Appliances,
                appliances: checkedAppliances,
                totalPower: newTotalPower,
                currentStep: checkedAppliances?.length === 0 && editItem?.item?.length !== 1 ? 2 : 3,
            });
        }
    };

    const handleEdit = (app: any, type = 'edit') => {
        setEditItem({ item: app, visible: true, type });
    };

    const handleCleanAll = () => {
        callBack({ ...calObj, apppliances: [], totalPower: 0, allAppliances: Appliances, currentStep: 2 });
        setCheckedFlag(false);
        setSelected([]);
        setTotalPower(0);
        setEditItem({ item: null, visible: false, type: 'edit' });
        setAllApplicances(Appliances);
        setCustomeFlag(true);
    };

    const onNext = () => {
        // const keys = selected.map((item: any) => item.key.replace('_', ' '))
        const keys: any = [];
        allAppliances?.map((item: any) => {
            selected?.forEach((ele: any) => {
                if (item.key === ele.key) {
                    keys.push(ele.key.replace('_', ' '));
                }
            });
        });
        callBack(
            {
                ...calObj,
                currentStep: calObj.currentStep + 1,
                currentPage: SolarCalcPage.Step4,
                appliances: selected,
                allAppliances,
                totalPower,
            },
            true,
        );

        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process3',
            step: 'Appliances',
            product_name: 'Ecoflow Solar Panel',
            option_name: keys,
            button_name: 'Next',
            consumption: `${totalPower}Kwh/day`,
        });
    };

    const onBack = () => {
        callBack(
            {
                ...calObj,
                currentStep: 2,
                currentPage: SolarCalcPage.Step2,
                appliances: null,
                allAppliances: null,
                totalPower: null,
            },
            true,
        );
    };

    const valiConfirm = (item: any) => {
        if (String(Number(item?.power)) === 'NaN' || String(Number(item?.time?.h)) === 'NaN' || String(Number(item?.time?.m)) === 'NaN') {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        if (
            Number(item?.power) <= 0 ||
            Number(item?.time?.h) < 0 ||
            Number(item?.time?.h) > 24 ||
            Number(item?.time?.m) < 0 ||
            Number(item?.time?.m) > 60 ||
            Number(item?.power) % 1 !== 0 ||
            Number(item?.time?.h) % 1 !== 0 ||
            Number(item?.time?.m) % 1 !== 0 ||
            (Number(item?.time?.h) === 24 && Number(item?.time?.m) !== 0) ||
            (Number(item?.time?.h) === 0 && Number(item?.time?.m) === 0)
        ) {
            return message.error(t(`calculators.mm100.step3.vali_error`));
        }
        return true;
    };

    const onModalConfirm = (item: any, type: string) => {
        if (valiConfirm(item)) {
            if (type === 'edit') {
                const newAllAppliances = allAppliances?.map((app: any) => (app.key === item.key ? item : app));
                setAllApplicances(newAllAppliances);
                const newTotalPower = calculateTotalPower(newAllAppliances, selected);
                setTotalPower(newTotalPower);
                callBack({
                    ...calObj,
                    allAppliances: newAllAppliances,
                    appliances: selected,
                    totalPower: newTotalPower,
                    currentStep: selected?.length === 0 && editItem?.item?.length !== 1 ? 2 : 3,
                });
            }
            if (type === 'add') {
                const newSelected = [...selected, item];
                const newAllAppliances = [...allAppliances, item];
                setSelected(newSelected);
                setAllApplicances(newAllAppliances);
                const newTotalPower = calculateTotalPower(newAllAppliances, newSelected);
                setTotalPower(newTotalPower);
                setCustomeFlag(false);
                callBack({
                    ...calObj,
                    allAppliances: newAllAppliances,
                    appliance: newSelected,
                    totalPower: newTotalPower,
                    currentStep: 3,
                });
            }
            setEditItem({ item: null, visible: false, type: 'edit' });
        }
    };

    const onModalCancel = () => {
        setEditItem({ item: null, visible: false, type: 'edit' });
    };

    const generateDesc = (app: any) => {
        return `${app?.power}W/${Number(app?.time?.h) ? Number(app?.time?.h) + t('calculators.mm100.step3.time_h_s') : ''}${
            Number(app?.time?.h) && Number(app?.time?.m) ? ' ' : ''
        }${Number(app?.time?.m) ? app?.time?.m + t('calculators.mm100.step3.time_m_s') : ''}${t('calculators.mm100.step3.per_day')}`;
    };

    return (
        <div className={`step3 step ${css.step3}`}>
            <div className="titleBox">
                <p className="title step3-title">{s('step3_title')}</p>
                <p className="cleanAllBtn" onClick={handleCleanAll}>
                    {s('step3_clear')}
                </p>
            </div>
            <div className="appliances">
                {allAppliances?.map((app: any) => (
                    <li className={`appliance ${selected.find((item: any) => item.key === app.key) ? 'active' : ''}`} key={app.key}>
                        <div className="appIcon">{app?.icon}</div>
                        <div className="appName">
                            <p className="name">{s(`step3_icon_${app.i18n}`)}</p>
                            <p className="power">{generateDesc(app)}</p>
                        </div>
                        <div className="editBtn" onClick={() => handleEdit(app)}>
                            {s('step3_edit')}
                        </div>
                        <div className="checkBox">
                            <Checkbox
                                checked={selected.find((item: any) => item.key === app.key) ? true : false}
                                onChange={(e: any) => handleChangeCheck(app, e)}
                            />
                        </div>
                    </li>
                ))}
                {customeFlag && (
                    <li className="custome-appliance appliance" onClick={() => handleEdit(custome, 'add')}>
                        <div className="appIcon">{custome?.icon}</div>
                        <div className="appName">
                            <p className="name">{s(`step3_icon_custome`)}</p>
                        </div>
                        <div className="plusBtn">+</div>
                    </li>
                )}
            </div>
            <div className="fix-footer">
                <div className="sum">
                    <div className="sumTotal">
                        {s.rich('step3_total', {
                            sum: (children: any) => <span className="num">{children}</span>,
                            totalPower: Math.round(totalPower * 100) / 100 || 0,
                        })}
                    </div>
                    <p className="refer">{s('step3_refer')}</p>
                </div>
                <div className="step3-btns">
                    <button className="btn-back" onClick={onBack}>
                        {s('common_back')}
                    </button>
                    <button className="btn-next" disabled={calObj?.totalPower <= 0} onClick={onNext}>
                        {s('common_next')}
                    </button>
                </div>
            </div>
            <ApplianceModal
                config={{ visible: editItem.visible }}
                item={editItem.item}
                type={editItem.type}
                onConfirm={onModalConfirm}
                onCancel={onModalCancel}
            />
        </div>
    );
}
